import { render, staticRenderFns } from "./glAudioPreview.vue?vue&type=template&id=8ef3f724&scoped=true"
import script from "./glAudioPreview.vue?vue&type=script&lang=js"
export * from "./glAudioPreview.vue?vue&type=script&lang=js"
import style0 from "./glAudioPreview.vue?vue&type=style&index=0&id=8ef3f724&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef3f724",
  null
  
)

export default component.exports